module.exports = __webpack_public_path__ + "static/media/award-badge.3032f678.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flight/award-badge.png
// module id = 1703
// module chunks = 0